var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 10,
    viewBox: "0 0 21 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4876 0.387695H12.6525C12.314 0.387695 12.0601 0.662748 12.0601 0.980116C12.0601 1.29748 12.3351 1.57254 12.6525 1.57254H15.4876C17.3707 1.57254 18.9152 3.11706 18.9152 5.00012C18.9152 6.88317 17.3707 8.42769 15.4876 8.42769H12.6525C12.314 8.42769 12.0601 8.70275 12.0601 9.02012C12.0601 9.35864 12.3351 9.61254 12.6525 9.61254H15.4876C18.0266 9.61254 20.1001 7.53906 20.1001 5.00012C20.1001 2.46117 18.0266 0.387695 15.4876 0.387695Z",
    fill: "#33D76F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44758 8.42769H4.61242C2.72937 8.42769 1.18484 6.88317 1.18484 5.00012C1.18484 3.11706 2.72937 1.57254 4.61242 1.57254H7.44758C7.78611 1.57254 8.04 1.29748 8.04 0.980116C8.04 0.662748 7.76495 0.387695 7.44758 0.387695H4.61242C2.07347 0.387695 0 2.46117 0 5.00012C0 7.53906 2.07347 9.61254 4.61242 9.61254H7.44758C7.78611 9.61254 8.04 9.33748 8.04 9.02012C8.04 8.68159 7.78611 8.42769 7.44758 8.42769Z",
    fill: "#33D76F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90869 4.99965C4.90869 5.33817 5.18374 5.59207 5.50111 5.59207H14.599C14.9375 5.59207 15.1914 5.31702 15.1914 4.99965C15.1914 4.66112 14.9164 4.40723 14.599 4.40723H5.50111C5.16259 4.40723 4.90869 4.66112 4.90869 4.99965Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkAccounts);
export default __webpack_public_path__ + "static/media/link-accounts.52f0aef0051407930cb814eb5d0d23fc.svg";
export { ForwardRef as ReactComponent };